export default "__VITE_ASSET__C2jO5GC4__"